import { isDevMode } from '@angular/core';
import { throwError } from 'rxjs';
import { ReportType } from '@app/domain/model/report-type';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DateFormatter } from '@app/util/date-formatter';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PaperCreditService = /** @class */ (function () {
    function PaperCreditService(http) {
        this.http = http;
    }
    PaperCreditService.prototype.addPaperCredit = function (report) {
        // Convert the purchase report into JSON representation, ...
        var requestBody = JSON.stringify(Object.assign({}, {
            dealerId: report.dealerId,
            reportType: ReportType[report.reportType],
            reportDate: DateFormatter.formatDateBeforeSend(report.reportDate),
            receivedDate: DateFormatter.formatDateBeforeSend(report.receivedDate)
        }));
        // ... and send it to the back-end.
        return this.http
            .post('credit/reports/add', requestBody, { headers: { 'Content-Type': 'application/json' } })
            .pipe(catchError(this.handleError));
    };
    PaperCreditService.prototype.handleError = function (error) {
        if (isDevMode()) {
            console.error('Add paper credit problem: ', error);
        }
        return throwError(error);
    };
    PaperCreditService.ngInjectableDef = i0.defineInjectable({ factory: function PaperCreditService_Factory() { return new PaperCreditService(i0.inject(i1.HttpClient)); }, token: PaperCreditService, providedIn: "root" });
    return PaperCreditService;
}());
export { PaperCreditService };
